import {
  FaBoxes,
  FaClipboard,
  FaClipboardList,
  FaHome,
  FaSimCard,
  FaSitemap,
  FaUser,
  FaUsers,
} from "react-icons/fa";
import Dashboard from "./views/Dashboard";
import Group from "./views/Group";
import Inventory from "./views/Inventory";
import InventoryReports from "./views/InventoryReports";
import Jobs from "./views/Jobs";
import Login from "./views/Login";
import Organization from "./views/Organization";
import OrganizationDetails from "./views/Organization/organizationDetails";
import Profile from "./views/profile";
import Sims from "./views/SIMs";
import UsersList from "./views/Users";

export var routes = [
  {
    path: "/home",
    name: "Home",
    icon: FaHome,
    component: Dashboard,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/organizations",
    name: "Organizations",
    icon: FaSitemap,
    component: Organization,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/organization/:id",
    name: "Organization Details",
    icon: FaSitemap,
    component: OrganizationDetails,
    layout: "/app",
    showInSideNav: false,
  },
  {
    path: "/users",
    name: "Users",
    icon: FaUser,
    component: UsersList,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/sims",
    name: "SIMs",
    icon: FaSimCard,
    component: Sims,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/inventory",
    name: "Inventory",
    icon: FaBoxes,
    component: Inventory,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/inventory-reports",
    name: "Inventory Reports",
    icon: FaClipboardList,
    component: InventoryReports,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/groups",
    name: "Groups",
    icon: FaUsers,
    component: Group,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/jobs",
    name: "Jobs",
    icon: FaClipboard,
    component: Jobs,
    layout: "/app",
    showInSideNav: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    layout: "/auth",
    showInSideNav: false,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    layout: "/app",
    showInSideNav: false,
  },
];

export const sideBarRoutes = routes.filter((route) => route.showInSideNav);
